import React from 'react';
import { ModuleStatus } from '../data/modules';

export default function StatusPill({ status }: { status: ModuleStatus }) {
  const isLive = status === 'Live';
  return (
    <span
      className={`text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${
        isLive ? 'bg-success/15 text-success' : 'bg-surface3 text-textTertiary'
      }`}
    >
      {isLive && <span className="inline-block w-1.5 h-1.5 rounded-full bg-success mr-1.5 align-middle" />}
      {status}
    </span>
  );
}
